export default __webpack_public_path__ + "locales/zh-CN/EmptyView.json?hash=77eefa2dcc8b6e255d81b072fccdabe9";